import React from "react";
import styles from "../../_css/Simulation.module.css";

// Inline SVG, because Windows shows a flag emoji as two letters ("DE").
// Only these ten markets have a flag; every other market gets the globe.
const FLAGS = {
  DE: (
    <>
      <rect width="3" height="2" fill="#000" />
      <rect width="3" height="1.333" y="0.667" fill="#D00" />
      <rect width="3" height="0.667" y="1.333" fill="#FFCE00" />
    </>
  ),
  AT: (
    <>
      <rect width="3" height="2" fill="#ED2939" />
      <rect width="3" height="0.667" y="0.667" fill="#fff" />
    </>
  ),
  CH: (
    <>
      <rect width="3" height="2" fill="#D52B1E" />
      <rect x="1.3" y="0.45" width="0.4" height="1.1" fill="#fff" />
      <rect x="0.95" y="0.8" width="1.1" height="0.4" fill="#fff" />
    </>
  ),
  FR: (
    <>
      <rect width="3" height="2" fill="#fff" />
      <rect width="1" height="2" fill="#002395" />
      <rect width="1" height="2" x="2" fill="#ED2939" />
    </>
  ),
  IT: (
    <>
      <rect width="3" height="2" fill="#fff" />
      <rect width="1" height="2" fill="#009246" />
      <rect width="1" height="2" x="2" fill="#CE2B37" />
    </>
  ),
  NL: (
    <>
      <rect width="3" height="2" fill="#fff" />
      <rect width="3" height="0.667" fill="#AE1C28" />
      <rect width="3" height="0.667" y="1.333" fill="#21468B" />
    </>
  ),
  PL: (
    <>
      <rect width="3" height="2" fill="#fff" />
      <rect width="3" height="1" y="1" fill="#DC143C" />
    </>
  ),
  ES: (
    <>
      <rect width="3" height="2" fill="#AA151B" />
      <rect width="3" height="1" y="0.5" fill="#F1BF00" />
    </>
  ),
  GB: (
    <>
      <rect width="3" height="2" fill="#012169" />
      <path d="M0,0 3,2 M3,0 0,2" stroke="#fff" strokeWidth="0.4" />
      <path d="M0,0 3,2 M3,0 0,2" stroke="#C8102E" strokeWidth="0.24" />
      <path d="M1.5,0 v2 M0,1 h3" stroke="#fff" strokeWidth="0.66" />
      <path d="M1.5,0 v2 M0,1 h3" stroke="#C8102E" strokeWidth="0.4" />
    </>
  ),
  US: (
    <>
      <rect width="3" height="2" fill="#fff" />
      <g fill="#B22234">
        <rect width="3" height="0.154" />
        <rect width="3" height="0.154" y="0.308" />
        <rect width="3" height="0.154" y="0.615" />
        <rect width="3" height="0.154" y="0.923" />
        <rect width="3" height="0.154" y="1.231" />
        <rect width="3" height="0.154" y="1.538" />
        <rect width="3" height="0.154" y="1.846" />
      </g>
      <rect width="1.2" height="1.077" fill="#3C3B6E" />
    </>
  ),
};

// Persona markets arrive as English country names ("Germany", "United Kingdom"),
// sometimes as a code ("USA").
const MARKET_CODES = {
  germany: "DE", de: "DE",
  austria: "AT", at: "AT",
  switzerland: "CH", ch: "CH",
  france: "FR", fr: "FR",
  italy: "IT", it: "IT",
  netherlands: "NL", "the netherlands": "NL", nl: "NL",
  poland: "PL", pl: "PL",
  spain: "ES", es: "ES",
  "united kingdom": "GB", uk: "GB", gb: "GB", "great britain": "GB",
  "united states": "US", "united states of america": "US", usa: "US", us: "US",
};

function MarketFlag({ market }) {
  const code = MARKET_CODES[String(market ?? "").trim().toLowerCase()];
  if (!code) {
    return (
      <span className={styles.personaMarketGlobe} aria-hidden="true">
        🌍
      </span>
    );
  }
  return (
    <svg
      className={styles.personaMarketFlag}
      viewBox="0 0 3 2"
      preserveAspectRatio="none"
      role="img"
      aria-label={code}
    >
      {FLAGS[code]}
    </svg>
  );
}

export default MarketFlag;
